import React from 'react';
import { RadioGroup } from '@mui/material';
import { useController } from 'react-hook-form';

export const RadioControlled = ({
  control,
  name,
  muiProps,
  callbackOnChange = () => {},
  children,
}) => {
  const {
    field: { onChange, value },
  } = useController({
    name,
    control,
  });

  return (
    <RadioGroup
      aria-label="form"
      name={name}
      value={value}
      onChange={(event) => {
        onChange(event);
        callbackOnChange(event);
      }}
      {...muiProps}
    >
      {children}
    </RadioGroup>
  );
};
